import React from "react";
import { useTranslation } from "react-i18next";

import ModalWindow from "../../ModalWindow";
import ClearFormConfirm from "./index";

function ClearFormModal({ onConfirm, buttonClassName }) {
    const { t } = useTranslation();

    return (
        <ModalWindow
            WindowComponent={ClearFormConfirm}
            ButtonComponent={({ onClick }) => (
                <button className={buttonClassName} type="button" onClick={onClick}>
                    {t("clear_button")}
                </button>
            )}
            onConfirm={onConfirm}
        />
    );
}

export default ClearFormModal;
